<div class="modal fade show" tabindex="-1" role="dialog" style="display: block;" aria-modal="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Abatimento de Boleto</h5>
        <button type="button" class="close" aria-label="Close" (click)="closeModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <label for="documento">Documento:</label>
          <input type="text" class="form-control" id="documento" [(ngModel)]="documento" disabled />
        </div>
        <div class="form-group">
          <label for="valor">Valor do Boleto:</label>
          <input type="number" class="form-control" id="valor" [(ngModel)]="valor" disabled />
        </div>
        <div class="form-group">
          <label for="data-vencimento">Vencimento:</label>
          <input type="date" class="form-control" id="data-vencimento" [(ngModel)]="dataVencimento" disabled />
        </div>
        <div class="form-group">
          <label for="novo-valor">Novo Valor:</label>
          <input type="number" class="form-control" id="novo-valor" #novoValor required />
        </div>
        <div class="form-group">
          <label for="motivo">Motivo:</label>
          <textarea
              class="form-control"
              id="motivo"
              #motivo
              required
              tooltip="No mínimo 10 caractéres"
            ></textarea>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeModal()">Fechar</button>
        <button
          type="button"
          class="btn btn-primary"
          (click)="onAbaterBoleto(novoValor.value, motivo.value, selectedItem)"
          [disabled]="!novoValor.value || !motivo.value || motivo.value.length < 10"
        >
          Solicitar Abatimento
        </button>
      </div>
    </div>
  </div>
</div>
